<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>> On/Off Sidemnue ------------------------------------------- -->
        <v-btn fab small @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<< On/Off Sidemnue ------------------------------------------- -->


        <!-- >>> Toolbar --------------------------------------------------- -->
		<v-toolbar-title class="hidden-sm-and-down">
            Vacations - Status Overview
        </v-toolbar-title>
        <!-- <<< Toolbar --------------------------------------------------- -->


		<!-- >>> Filter TextField ------------------------------------------ -->
		<sdr-vacations-appbar-searchbox />
		<!-- <<< Filter TextField ------------------------------------------ -->


        <v-spacer />


        <!-- >>> Menue: Download Calendar ---------------------------------- -->
        <download-menue-view v-if="get_shared_IsDutyAccessAllowed === true" style="margin-right: 30px;" />
        <!-- <<< Menue: Download Calendar ---------------------------------- -->


        <!-- >>> Menue: Filter/Search Calendar ----------------------------- -->
        <filter-menue-view style="margin-right: 20px;" />
        <!-- <<< Menue: Filter/Search Calendar ----------------------------- -->
	</v-app-bar>
</template>

<script>
	import SearchBox from './SearchBox.vue';
    import FilterMenueView from '../FilterMenue.vue';
    import DownloadMenueView from '../DownloadMenue.vue';

	import { mapGetters } from 'vuex';


	export default {
		name: 'VacationsStausOverViewAppBar',

		/* >>> *************************************************************** / /* Components */
		components: {

            FilterMenueView,
            DownloadMenueView,
			'sdr-vacations-appbar-searchbox': SearchBox

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
                'getIdGroup',
                'get_shared_IsDutyAccessAllowed'
			])

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {



        } // eo methods{}
        /* <<< ****************************************************************/

	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }
</style>
